module.exports = __webpack_public_path__ + "media/images/emoticons/tulip-322d4ab76a859c1cf97cbfe1d933e53a.gif";